import { useRutilusQuery } from '@graphql/client/useRutilusQuery';
import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';
import { getPostLikers } from '@graphql/queries/rutilus/Posts';
import { isLiker } from '../../../types/isLiker';
import type { Liker } from '../../../types/Liker';

interface CatchLikersData {
  likers: Liker[];
  isLoading: boolean;
}

export const usePostLikers = (postId: string): CatchLikersData => {
  const { data, loading: isLoading } = useRutilusQuery(getPostLikers, {
    variables: { externalId: postId },
    fetchPolicy: 'cache-and-network',
  });
  const likers = getNodesFromConnection(data?.post.likers).filter(isLiker);

  return { likers, isLoading };
};
